import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Send } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function MiniCTA() {
  const { t } = useLang();

  return (
    <section className="relative py-12 px-6 overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto"
      >
        <div 
          className="relative overflow-hidden rounded-2xl p-8 md:p-10 text-center"
          style={{
            background: 'linear-gradient(135deg, rgba(212,175,55,0.1) 0%, rgba(107,78,255,0.1) 100%)',
            border: '1px solid rgba(212,175,55,0.3)',
            boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          }}
        >
          <p className="text-[#D4AF37] text-sm md:text-base font-bold uppercase tracking-wider mb-4">
            {t.cta?.ready || 'Готовы начать?'}
          </p>
          <h3 className="text-2xl md:text-3xl font-black font-heading text-white mb-6">
            {t.cta?.contact || 'Свяжитесь с нами'}
          </h3>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+34624586917"
              className="btn-call flex items-center gap-2 px-6 py-3 rounded-full text-sm font-bold w-full sm:w-auto justify-center"
            >
              <Phone size={16} />
              {t.nav?.call || 'Позвонить'}
            </a>
            <a
              href="https://t.me/SerjValencia"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-telegram flex items-center gap-2 px-6 py-3 rounded-full text-sm font-bold w-full sm:w-auto justify-center"
            >
              <Send size={16} />
              Telegram
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
